module.exports = __webpack_public_path__ + "static/media/task_complete.0715e3c1.png";